import { ChangeDetectionStrategy, Component, OnInit, forwardRef } from '@angular/core';
import { CheckoutSuccessComponentDef } from '@df/checkout/checkout-success.component.def';
import { CheckoutSuccessLayoutComponent } from './layout/checkout-success-layout.component';

@Component({
    selector: 'checkout-success',
    template: '<checkout-success-layout></checkout-success-layout>',
    standalone: true,
    imports: [forwardRef(() => CheckoutSuccessLayoutComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSuccessComponent extends CheckoutSuccessComponentDef implements OnInit {
    protected override onRegister() {
        this.router.navigate(['/account']);
    }
}
